import { getObject, postObject, combinePaths, deleteObject} from "../ChoiceApi";
import { IResult } from "../Models/Result";
import { ICompanies}  from "./Sentinel";

export enum ReasonCategoryOptions{
  SupportCase = "Support Case",
  DevopsTicket = "Devops Ticket",
  ProfessionalServices = "Professional Services",
  Other = "Other"
}



export interface INewEnhancedAccessRequest{
    ReasonCategory : ReasonCategoryOptions,
    TicketNumber : string,
    ReasonBody : string
}

export interface IEnhancedAccessAuditReportEntry{
    AuditID: number,
    UserID: string,
    ReasonCategory: ReasonCategoryOptions,
    TicketNumber: string,
    ReasonBody: string,
    DatabaseKey: string,
    PostDate: string
}
export interface IEnhancedAccessAuditReportDisplay{
    AuditID: number,
    UserID: string,
    ReasonCategory: ReasonCategoryOptions,
    TicketNumber: string,
    ReasonBody: string,
    DatabaseKey: string,
    PostDate: string,
    DatabaseName: string
}

export interface IEnhancedAccessAuditReportSearch{
    UserIDSearch : string | undefined,
    ReasonFilterCategories : ReasonCategoryOptions[] | undefined,
    TicketNumberSearch : string | undefined,
    ReasonBodySearch : string | undefined,
    DatabaseKeyFilters: string[] | undefined,
    StartDate: string | undefined,
    EndDate: string | undefined
}
const enhancedReasonURL = "/api/MainWindow/EnhancedAccess/";
const enhancedReportURL = "/api/Reporting/EnhancedAccessAuditReport/";
export async function requestAccess(newRequest:INewEnhancedAccessRequest):Promise<IResult | undefined>{
    let fullUrl = combinePaths([enhancedReasonURL, 'Request'],false);
    return await postObject(fullUrl, newRequest);
}
export async function removeAccess():Promise<IResult | undefined>{
    let fullUrl = combinePaths([enhancedReasonURL, 'Remove'],false);
    return await deleteObject(fullUrl);
}
export async function checkAccess():Promise<boolean | undefined>{
    let fullUrl = combinePaths([enhancedReasonURL, 'CheckAccess'],false);
    return await getObject(fullUrl);
}
export async function generateReport(reportSearch:IEnhancedAccessAuditReportSearch):Promise<IEnhancedAccessAuditReportEntry[] | undefined>{
    let fullUrl = combinePaths([enhancedReportURL, 'GenerateReport'],false);
    return await postObject(fullUrl, reportSearch);
}
export async function getOMDCompanies():Promise<ICompanies[] | undefined>{
    return await getObject('api/Companies/OMD');
}